export default {
  PROVISION_SUCCESS: 'PROVISION_SUCCESS',
  SOFT_PROVISION_SUCCESS: 'SOFT_PROVISION_SUCCESS'
};
